(() => {
  'use strict';

  const DATA = window.PAROSICART_VARIANT_MEDIA;
  if (!DATA || !Array.isArray(DATA.media)) return;

  const state = {
    gallery: null,
    color: '',
    images: [],
    index: 0,
    timers: []
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const getPicker = () => document.querySelector('main variant-picker[data-template-product-match="true"]') || document.querySelector('variant-picker[data-template-product-match="true"]');

  const getColorValueFromPicker = () => {
    const picker = getPicker();
    if (!picker) return '';

    const select = picker.querySelector('select[name="options[Color]"], select[name="options[Colour]"]');
    if (select?.value) return String(select.value).trim();

    const radio = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]'))
      .find((input) => input.checked && /^(color|colour)$/i.test(String(input.dataset.optionName || '').trim()));
    if (radio?.value) return String(radio.value).trim();

    const firstOptionRadio = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]'))
      .find((input) => input.checked);
    if (firstOptionRadio?.value && DATA.colors?.length === 1) return String(firstOptionRadio.value).trim();

    return '';
  };

  const matchesColor = (media, color) => {
    const wanted = normalize(color);
    if (!wanted) return false;

    const haystack = normalize(`${media.alt || ''} ${media.url || ''}`);
    if (!haystack) return false;

    return haystack.includes(wanted);
  };

  const getImagesForColor = (color) => {
    const images = DATA.media.filter((media) => media.type === 'image' && media.url);
    if (!images.length) return [];

    const exactMatches = images.filter((media) => matchesColor(media, color));
    if (exactMatches.length) return exactMatches;

    const colors = Array.isArray(DATA.colors) ? DATA.colors : [];
    const colorIndex = colors.findIndex((value) => normalize(value) === normalize(color));
    if (colorIndex >= 0 && colors.length > 0 && images.length % colors.length === 0) {
      const perColor = images.length / colors.length;
      return images.slice(colorIndex * perColor, (colorIndex + 1) * perColor);
    }

    return images;
  };

  const setCurrent = (index) => {
    if (!state.images.length) return;
    state.index = Math.max(0, Math.min(index, state.images.length - 1));
    render();
  };

  const render = () => {
    const gallery = state.gallery;
    if (!gallery) return;

    const main = gallery.querySelector('[data-parosicart-main-image]');
    const thumbs = gallery.querySelector('[data-parosicart-thumbs]');
    if (!main || !thumbs) return;

    const current = state.images[state.index] || state.images[0];
    if (!current) return;

    main.src = current.url;
    main.alt = current.alt || '';

    thumbs.replaceChildren();

    state.images.forEach((media, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'parosicart-variant-gallery__thumb';
      button.setAttribute('role', 'listitem');
      button.setAttribute('aria-current', index === state.index ? 'true' : 'false');
      button.setAttribute('aria-label', `View image ${index + 1}`);

      const img = document.createElement('img');
      img.src = media.url;
      img.alt = media.alt || '';
      img.loading = 'lazy';
      button.appendChild(img);

      button.addEventListener('click', () => setCurrent(index));
      thumbs.appendChild(button);
    });

    gallery.classList.toggle('has-multiple-images', state.images.length > 1);
    gallery.classList.add('is-ready');
  };

  const refresh = (forcedColor = '') => {
    const color = String(forcedColor || getColorValueFromPicker()).trim();
    if (!color) return;

    const images = getImagesForColor(color);
    if (!images.length) return;

    const colorChanged = normalize(color) !== normalize(state.color);
    state.color = color;
    state.images = images;
    if (colorChanged || state.index >= images.length) state.index = 0;
    render();
  };

  const moveIntoNativeGalleryPosition = () => {
    const custom = document.querySelector('[data-parosicart-gallery]');
    if (!custom) return false;

    const nativeGallery = document.querySelector('main media-gallery') || document.querySelector('media-gallery');
    if (!nativeGallery) return false;

    if (!custom.classList.contains('parosicart-gallery-positioned')) {
      nativeGallery.replaceWith(custom);
      custom.classList.add('parosicart-gallery-positioned');
    }

    state.gallery = custom;
    return true;
  };

  const scheduleRefresh = (forcedColor = '') => {
    state.timers.forEach((timer) => clearTimeout(timer));
    state.timers = [
      setTimeout(() => refresh(forcedColor), 0),
      setTimeout(() => refresh(forcedColor), 80),
      setTimeout(() => refresh(forcedColor), 250),
      setTimeout(() => refresh(forcedColor), 600)
    ];
  };

  const init = () => {
    if (!moveIntoNativeGalleryPosition()) return false;

    const picker = getPicker();
    if (picker && !picker.dataset.parosicartGalleryBound) {
      picker.dataset.parosicartGalleryBound = 'true';

      picker.addEventListener('change', (event) => {
        const target = event.target;
        if (target instanceof HTMLInputElement || target instanceof HTMLSelectElement) {
          const optionName = String(target.dataset.optionName || '');
          const forcedColor = /^(color|colour)$/i.test(optionName) ? target.value : '';
          scheduleRefresh(forcedColor);
        } else {
          scheduleRefresh();
        }
      });

      const observer = new MutationObserver(() => scheduleRefresh());
      observer.observe(picker, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['checked', 'data-current-checked', 'value', 'selected']
      });
    }

    refresh();
    return true;
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-parosicart-prev]')) {
      event.preventDefault();
      if (state.images.length > 1) setCurrent((state.index - 1 + state.images.length) % state.images.length);
    }
    if (target.closest('[data-parosicart-next]')) {
      event.preventDefault();
      if (state.images.length > 1) setCurrent((state.index + 1) % state.images.length);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (init() || attempts >= 30) clearInterval(timer);
    }, 100);
  }, { once: true });

  if (document.readyState !== 'loading') {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (init() || attempts >= 30) clearInterval(timer);
    }, 100);
  }
})();
